import {Injectable} from '@angular/core';
import {concat, Observable, of, timer} from 'rxjs';
import {NavigationStart, Router} from '@angular/router';
import {filter, map, publishReplay, refCount, switchMap} from 'rxjs/operators';
import {Ref, Role, Ticket, UserAuthService} from '@lifeislife/lifeislife-domain';


@Injectable({
  providedIn: 'root',
})
export class NavigationService {

  routeProtected$: Observable<boolean>;
  mandateRouteActive$: Observable<boolean>;

  constructor(
    private router: Router,
    private userAuthService: UserAuthService,
  ) {

    const navigationStarts$: Observable<NavigationStart> = this.router.events.pipe(
      filter(e => e instanceof NavigationStart),
      map(e => e as NavigationStart),
      publishReplay(1), refCount(),
    );


    // Force restore auth on each navigation if required. When coming back with a redirect to an unprotected page
    // (eg: /packagesigned), we need to restore the session for logged in users.

    const restoreAuthSubscription = concat([of(null), navigationStarts$]).pipe(
      switchMap(e => this.userAuthService.restoreAuthIfRequired$(this.router.routerState.root.snapshot.queryParamMap, Role.CUSTOMER)),
    ).subscribe(
      u => {
      },
      e => console.warn(e),
    );
    const navigationSubscription = navigationStarts$
      .subscribe(() => this.onNavigation());

    this.routeProtected$ = concat(of(null), navigationStarts$).pipe(
      map(a => this.isRouteProtected(a)),
      publishReplay(1), refCount(),
    );
    this.mandateRouteActive$ = concat(of(null), navigationStarts$).pipe(
      map(a => this.isMandateRoute(a)),
      publishReplay(1), refCount(),
    );
  }

  goToMandateRequest(ticketRef?: Ref<Ticket>) {
    this.router.navigate(['/mandate'], {
      queryParams: {
        ticketId: ticketRef == null ? undefined : ticketRef.id,
      },
    });
  }

  goToProducts() {
    this.router.navigate(['/products']);
  }

  navigateToUrl(url: string, delayMs = 0) {
    if (url) {
      if (window && window.location) {
        timer(delayMs).subscribe(() => {
          window.location.assign(url);
        });
      }
    }
  }


  private isRouteProtected(navigationStart: NavigationStart) {
    let routeUrl;
    if (navigationStart == null) {
      const routeSnapshot = this.router.routerState.snapshot;
      routeUrl = routeSnapshot.url;
    } else {
      routeUrl = navigationStart.url;
    }


    // FIXME!
    const loginRoute = routeUrl.indexOf('/login') >= 0;
    const packageSignedRoute = routeUrl.indexOf('/packagesigned') >= 0;
    const fileNotFoundRoute = routeUrl.indexOf('/filenotfound') >= 0;
    if (loginRoute || packageSignedRoute || fileNotFoundRoute) {
      return false;
    }
    return true;
  }

  private isMandateRoute(navigationStart: NavigationStart) {
    let routeUrl;
    if (navigationStart == null) {
      const routeSnapshot = this.router.routerState.snapshot;
      routeUrl = routeSnapshot.url;
    } else {
      routeUrl = navigationStart.url;
    }
    const mandateRoute = routeUrl.indexOf('/mandate') >= 0;
    return mandateRoute;
  }

  private onNavigation() {
  }
}
